export default "__VITE_ASSET__05c57944__"